import $ from 'jquery'

export default class StoreFinder {
  constructor (el) {
    const google = window.google
    const bounds = new google.maps.LatLngBounds()
    const maplis = {
      mapTypeId: 'roadmap',
      zoom: 4,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT
      },
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP
      },
      styles: [
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e9e9e9'
            },
            {
              lightness: 17
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5'
            },
            {
              lightness: 20
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ffffff'
            },
            {
              lightness: 17
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#ffffff'
            },
            {
              lightness: 29
            },
            {
              weight: 0.2
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff'
            },
            {
              lightness: 18
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff'
            },
            {
              lightness: 16
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5'
            },
            {
              lightness: 21
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dedede'
            },
            {
              lightness: 21
            }
          ]
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#ffffff'
            },
            {
              lightness: 16
            }
          ]
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              saturation: 36
            },
            {
              color: '#333333'
            },
            {
              lightness: 40
            }
          ]
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [
            {
              color: '#f2f2f2'
            },
            {
              lightness: 19
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#fefefe'
            },
            {
              lightness: 20
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#fefefe'
            },
            {
              lightness: 17
            },
            {
              weight: 1.2
            }
          ]
        }
      ]
    }

    // Display a map on the page
    const map = new google.maps.Map(
      document.getElementById('map-Canvas'),
      maplis
    )
    map.setTilt(45)

    // Get the stores & data from shopify section information
    let stores = []

    // Multiple Markers
    const markers = stores

    // Loop through our array of markers & place each one on the map
    const shopsMarkers = []
    const infowindows = []

    function getMarkers () {
      stores = []
      $('.stf-Item_Row').each(function () {
        const $this = $(this)
        stores.push([
          $this.data('name'),
          $this.data('lat'),
          $this.data('lng'),
          $this.data('type'),
          $this.data('country'),
          $this.data('id')
        ])
      })
      return stores
    }

    function removeMarkers (markersArray) {
      for (let i = 0; i < markersArray.length; i++) {
        markersArray[i].setMap(null)
      }
    }

    function setMarkers (locations) {
      let i = shopsMarkers.length
      while (i--) {
        shopsMarkers.splice(i, 1)
      }

      for (let i = 0; i < locations.length; i++) {
        ;(function () {
          const j = i
          const position = new google.maps.LatLng(
            locations[i][1],
            locations[i][2]
          )
          const category = locations[i][3]
          const region = locations[i][4]

          const icon = {
            url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
          }

          bounds.extend(position)
          shopsMarkers.push(
            new google.maps.Marker({
              position,
              map,
              category,
              id: locations[i][5],
              title: locations[i][0],
              region,
              icon
            })
          )

          infowindows[i] = new google.maps.InfoWindow({
            content: `<div class='marker-content'>${$(
              `.stf-Item_Row .stf-Text_Name:contains('${locations[i][0]}')`
            )
              .parent()
              .html()}</div>`
          })

          shopsMarkers[i].addListener('click', function () {
            for (i = 0; i < locations.length; i++) {
              infowindows[i].close()
            }
            infowindows[j].open(map, shopsMarkers[j])
          })
        })()
      }
    }

    setMarkers(getMarkers('all', 'all'))

    /**
     * Function to filter markers by category
     */

    // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
    const boundsListener = google.maps.event.addListener(
      map,
      'bounds_changed',
      function (event) {
        this.setZoom(4)
        google.maps.event.removeListener(boundsListener)
      }
    )
    const latLng = new google.maps.LatLng(38.283416, -95.367321) // Makes a latlng
    map.panTo(latLng) // Make map global

    /* Postcode search */
    const inputAutocomplete = document.getElementById('inputAutocomplete')
    const autocomplete = new google.maps.places.Autocomplete(inputAutocomplete)

    const activeIcon = {
      url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
    }

    autocomplete.bindTo('bounds', map)

    // Set the data fields to return when the user selects a place.
    autocomplete.setFields(['address_components', 'geometry', 'icon', 'name'])

    const marker = new google.maps.Marker({
      map,
      icon: activeIcon,
      anchorPoint: new google.maps.Point(0, -29)
    })

    autocomplete.addListener('place_changed', function () {
      marker.setVisible(false)
      const place = autocomplete.getPlace()
      const yourAddress = $('.salons-address').val()
      // If the place has a geometry, then present it on a map.
      map.fitBounds(place.geometry.viewport)
      map.setZoom(9) // Why 17? Because it looks good.

      map.setCenter(place.geometry.location)
      map.setZoom(9) // Why 17? Because it looks good.

      marker.setPosition(place.geometry.location)
      marker.setVisible(true)

      $('.stf-Row_Button-directions').each(function () {
        const href = $(this).attr('href')
        const hrefNew = `${href.split('saddr=')[0]}saddr=${yourAddress}`
        $(this).attr('href', hrefNew)
      })
    })

    const calcDistance = (p1, p2) => {
      return (
        (
          google.maps.geometry.spherical.computeDistanceBetween(p1, p2) / 1000
        ).toFixed(2) * 0.621371
      )
    }

    const hideInRadius = (distance, shopsMarkers) => {
      for (let i = 0; i < shopsMarkers.length; i++) {
        if (marker.getPosition()) {
          const distanceBetween = calcDistance(
            marker.getPosition(),
            shopsMarkers[i].getPosition()
          )
          if (distanceBetween > distance) {
            shopsMarkers[i].setVisible(false)
          } else {
            shopsMarkers[i].setVisible(true)
          }
        }
      }
    }

    /* Click a link in the left column to reveal infowindow on the map */
    $('.stf-Item_Row').click(function (e) {
      if (!e.target.classList.contains('stf-Row_Button')) {
        const markerId = $(this).data('id')
        for (let i = 0; i < shopsMarkers.length; i++) {
          if (markerId === shopsMarkers[i].id) {
            google.maps.event.trigger(shopsMarkers[i], 'click')
          }
        }
        $('.stf-Item_Row').removeClass('stf-Item_Row-active')
        $(this).addClass('stf-Item_Row-active')
      }
    })

    $('.stf-SelectOption-selected').click(function () {
      const $this = $(this)
      $('.stf-Select_Options')
        .not($this.parent().find('.stf-Select_Options'))
        .slideUp(function () {})
      $this
        .parent()
        .find('.stf-Select_Options')
        .slideToggle()
    })

    $('.stf-Select_Option').click(function (e) {
      const name = $(this).data('name')
      const value = $(this).data('value')
      $(this)
        .parent()
        .parent()
        .find('.stf-SelectOption-selected')
        .data('value', value)
      $(this)
        .parent()
        .slideUp()
      const distance = $('.stf-SelectOption-distanceSelected').data('value')
      if (
        $(this)
          .parent()
          .attr('id') === 'distance' &&
        distance !== 'all'
      ) {
        if (marker.getPosition()) {
          $('.stf-Item_Row').each(function () {
            const storeLat = $(this).data('lat')
            const storeLng = $(this).data('lng')
            const storeCord = new google.maps.LatLng(storeLat, storeLng)
            const distanceBetween = calcDistance(
              marker.getPosition(),
              storeCord
            )
            if (distanceBetween > distance) {
              $(this).attr('data-distance-show', 'false')
            } else {
              $(this).attr('data-distance-show', 'true')
            }
          })
        } else {
          $('#inputAutocomplete').focus()
          return
        }
      }
      $(this)
        .parent()
        .parent()
        .find('.stf-SelectOption-selected')
        .text(name)
      $(this)
        .parent()
        .find('.stf-Select_Option')
        .removeClass('stf-Select_Option-active')
      $(this).addClass('stf-Select_Option-active')

      $('.stf-Item_Row').hide()
      const distanceProperties = "[data-distance-show='true']"
      const filterProperties = distanceProperties
      $(`.stf-Item_Row${filterProperties}`).show()
      if ($('.stf-Item_Row').length === $('.stf-Item_Row:hidden').length) {
        $('.stf-Item_Info').text('Sorry, no results match your criteria')
      } else {
        $('.stf-Item_Info').text(
          `${$('.stf-Item_Row:visible').length} locations found`
        )
      }
      hideInRadius(distance, shopsMarkers)
    })
  }
}
